/* eslint-disable react/prop-types */
import ReactEChartsCore from 'echarts-for-react/lib/core';
import { BarChart } from 'echarts/charts';
import {
  DatasetComponent,
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent
} from 'echarts/components';
import * as echarts from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { getColor } from 'helpers/utils';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { round } from 'lodash';
import { Card, Col, Form, Row } from 'react-bootstrap';
import FalconCardHeader from 'components/common/FalconCardHeader';

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  BarChart,
  CanvasRenderer,
  LegendComponent,
  DatasetComponent
]);

const tooltipFormatter = (params, unit, colors, decimalPoint) => {
  const validParams = params.filter(
    param => param.value !== '' && param.value != null
  );

  if (validParams.length === 0) return '';

  const tooltipContent = validParams
    .map(param => {
      const value = param.value === 0 ? '0' : param.value.toFixed(decimalPoint);
      const color = param.color;

      return `
      <p class='mb-0 text-600 fs--1'>
        <span style='display: inline-block; width: 10px; height: 10px; border-radius: 50%; background-color: ${color}; margin-right: 5px;'></span>
        ${param.seriesName}: <span class='text-800 fw-semi-bold fs--1'>${value} <span class='text-500 fw-normal fs--1'>${unit}</span></span>
      </p>`;
    })
    .join('');

  return `
    ${
      validParams.length > 0
        ? `<h6 class="fs--2 mb-0 fw-semi-bold">${params[0].axisValueLabel}</h6>`
        : ''
    }
    <div class="align-items-center">${tooltipContent}</div>`;
};

const getOption = (result, date, unit, type, decimalPoint) => {
  // const colors = ['#5470C6', '#91CC75', '#ff4f4f'];
  const colors = ['#5470C6', '#91CC75', '#ff4f4f', '#C966ED'];
  const legendData = Object.keys(result);

  const series = legendData.map((key, index) => ({
    name: key,
    type: type,
    data: result[key],
    color: colors[index % colors.length]
  }));

  return {
    color: colors,
    // tooltip: {
    //   trigger: 'axis',
    //   axisPointer: {
    //     type: type === 'line' ? 'line' : 'shadow'
    //   },
    //   formatter: params => {
    //     let result = `${params[0].axisValue}<br/>`;
    //     params.forEach(item => {
    //       result += `${item.marker} ${item.seriesName}: ${item.value.toFixed(
    //         decimalPoint
    //       )} ${unit}<br/>`;
    //     });
    //     return result;
    //   }
    // },
    tooltip: {
      trigger: 'axis',
      padding: [7, 10],
      backgroundColor: getColor('gray-100'),
      borderColor: getColor('gray-300'),
      textStyle: { color: getColor('dark') },
      borderWidth: 1,
      transitionDuration: 0,
      valueFormatter: function (value) {
        return value + ` ${unit}`;
      }
    },
    grid: {
      right: '5%',
      left: '5%',
      bottom: '10%',
      containLabel: true
    },
    legend: {
      data: legendData,
      icon: 'circle'
    },
    xAxis: [
      {
        type: 'category',
        data: date
      }
    ],
    yAxis: [
      {
        type: 'value',
        axisLine: {
          show: true
        }
        // axisLabel: {
        //   formatter: `{value} ${unit}`
        // }
      }
    ],
    series: series
  };
};

const MultiParamsBarChart = ({ chartData, type }) => {
  let results = chartData?.data;
  let date = chartData?.series;
  let unit = chartData?.unit;
  let variant = chartData?.variant;
  // let sortedYear = results.sort((a, b) => parseInt(b.year) - parseInt(a.year));
  const [selectedYear, setSelectedYear] = useState(variant[0]);

  const [selectedYearData, setSelectedYearData] = useState(null); // Initialize as null
  const [key, setKey] = useState(0);

  let decimalPoint = 2;
  if (
    chartData?.label == 'Nitrogen Dioxide' ||
    chartData?.label == 'Carbon Monoxide' ||
    chartData?.label == 'Sulphur Dioxide'
  ) {
    decimalPoint = 5;
  }

  const handleSelectChange = event => {
    setSelectedYear(event.target.value);
  };

  useEffect(() => {
    const foundYearData = results[selectedYear];
    setSelectedYearData(foundYearData);
  }, [chartData, selectedYear, results]);

  useEffect(() => {
    setKey(prevKey => prevKey + 1);
  }, [selectedYearData]);

  return (
    <Card className="h-100">
      <FalconCardHeader
        title={chartData?.label}
        light={true}
        titleTag="h5"
        desc={chartData?.desc}
        endEl={
          variant?.length > 1 && (
            <Row className="align-items-center">
              <Col className="ps-2 py-0">
                <Form.Select value={selectedYear} onChange={handleSelectChange}>
                  {variant?.map(entry => (
                    <option key={entry} value={entry}>
                      {entry}
                    </option>
                  ))}
                </Form.Select>
              </Col>
            </Row>
          )
        }
      />
      <Card.Body className="h-100   position-relative" dir="ltr">
        {selectedYearData && (
          <ReactEChartsCore
            echarts={echarts}
            option={getOption(selectedYearData, date, unit, type, decimalPoint)}
            style={{ minHeight: '27.75rem' }}
            key={key}
          />
        )}
        <p
          style={{
            fontSize: '12px',
            position: 'absolute',
            top: '20px',
            right: '20px'
          }}
        >
          {unit}
        </p>
      </Card.Body>
    </Card>
  );
};

export default MultiParamsBarChart;
